import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ContactForm } from '../components/ContactForm'
import { sendEmail, setErrorMsg, setSuccessMsg, resetMsgs } from '../redux/actions/actions'
import { withNamespaces } from 'react-i18next'

class ContactFormContainer extends Component {
	componentWillUnmount () {
		const { dispatch } = this.props
		dispatch(resetMsgs())
	}

	render () {
		return <ContactForm {...this.props}/>
	}
}

const mapStateToProps = state => {
	return {
		successMessage: state.messages.success,
		errorMessage: state.messages.error
	}
}
const mapDispatchToProps = (dispatch, props) => {
	return {
		onChange: () => dispatch(resetMsgs()),
		onSubmit: data => { 
			const { t } = props
			if (data.email && data.name && data.message) {
			dispatch(sendEmail(data))
				.then( () => {
					dispatch(setSuccessMsg(t('messages.messageSentSuccessfully')))
				})
				.catch( err => {
					dispatch(setErrorMsg(t('messages.errorSendingMessage')))
				})
			} else {
				dispatch(setErrorMsg(t('messages.requiredFields')))
			}
		}
	}
}

export default withNamespaces()(connect(mapStateToProps,mapDispatchToProps)(reduxForm({ form: 'contactForm' })(ContactFormContainer)))



// WEBPACK FOOTER //
// ./src/containers/ContactFormContainer.js